export const semanticConfig = {
  bg: {
    DEFAULT: {
      value: { _light: '{colors.gray.100}', _dark: '{colors.gray.900}' },
    },
    muted: {
      value: { _light: '{colors.gray.400}', _dark: '{colors.gray.600}' },
    },
    subtle: {
      value: { _light: '{colors.gray.300}', _dark: '{colors.gray.700}' },
    },
    subdued: {
      value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' },
    },
    emphasized: {
      value: { _light: '{colors.gray.500}', _dark: '{colors.gray.500}' },
    },

    inverted: {
      value: { _light: '{colors.gray.900}', _dark: '{colors.white}' },
    },
    panel: {
      value: { _light: '{colors.gray.50}', _dark: '{colors.gray.950}' },
    },
    info: { value: { _light: '{colors.blue.50}', _dark: '{colors.blue.900}' } },
    error: { value: { _light: '{colors.red.50}', _dark: '{colors.red.950}' } },
    warning: {
      value: { _light: ' {colors.orange.50}', _dark: '{colors.orange.950}' },
    },
    success: {
      value: { _light: '{colors.green.50}', _dark: '{colors.green.950}' },
    },
  },

  border: {
    DEFAULT: {
      value: { _light: '{colors.gray.400}', _dark: '{colors.gray.600}' },
    },
    muted: {
      value: { _light: '{colors.gray.300}', _dark: '{colors.gray.700}' },
    },
    subtle: {
      value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' },
    },
    subdued: {
      value: { _light: '{colors.gray.100}', _dark: '{colors.gray.900}' },
    },
    emphasized: {
      value: { _light: '{colors.gray.500}', _dark: '{colors.gray.500}' },
    },
    inverted: {
      value: { _light: '{colors.gray.900}', _dark: '{colors.gray.100}' },
    },
    info: {
      value: { _light: '{colors.blue.500}', _dark: '{colors.blue.400}' },
    },
    error: { value: { _light: '{colors.red.600}', _dark: '{colors.red.500}' } },
    warning: {
      value: { _light: ' {colors.orange.600}', _dark: '{colors.orange.500}' },
    },
    success: {
      value: { _light: '{colors.green.600}', _dark: '{colors.green.500}' },
    },
  },

  fg: {
    DEFAULT: { value: { _light: '{colors.black}', _dark: '{colors.white}' } },
    muted: {
      value: { _light: '{colors.gray.800}', _dark: '{colors.gray.200}' },
    },
    subtle: {
      value: { _light: '{colors.gray.700}', _dark: '{colors.gray.300}' },
    },
    subdued: {
      value: { _light: '{colors.gray.500}', _dark: '{colors.gray.400}' },
    },
    emphasized: {
      value: { _light: '{colors.gray.800}', _dark: '{colors.gray.50}' },
    },
    inverted: { value: { _light: '{colors.white}', _dark: '{colors.black}' } },
    info: {
      value: { _light: '{colors.info}', _dark: '{colors.info}' },
    },
    error: { value: { _light: '{colors.red.600}', _dark: '{colors.red.500}' } },
    errorSubtle: {
      value: { _light: '{colors.red.50}', _dark: '{colors.red.950}' },
    },
    warning: {
      value: { _light: ' {colors.orange.600}', _dark: '{colors.orange.500}' },
    },
    success: {
      value: { _light: '{colors.green.600}', _dark: '{colors.green.500}' },
    },
  },

  gray: {
    contrast: { value: { _light: '{colors.white}', _dark: '{colors.black}' } },
    fg: { value: { _light: '{colors.gray.600}', _dark: '{colors.gray.400}' } },
    muted: {
      value: { _light: '{colors.gray.300}', _dark: '{colors.gray.700}' },
    },
    subtle: {
      value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' },
    },
    subdued: {
      value: { _light: '{colors.gray.100}', _dark: '{colors.gray.900}' },
    },

    emphasized: {
      value: { _light: '{colors.gray.400}', _dark: '{colors.gray.600}' },
    },
    solid: { value: { _light: '{colors.gray.900}', _dark: '{colors.white}' } },
    focusRing: {
      value: { _light: '{colors.gray.400}', _dark: '{colors.gray.400}' },
    },
  },

  primary: {
    contrast: { value: { _light: '{colors.white}', _dark: '{colors.white}' } },
    fg: {
      value: { _light: '{colors.terracotta.700}', _dark: '{colors.terracotta.300}' },
    },
    bg: {
      value: { _light: '{colors.terracotta.100}', _dark: '{colors.terracotta.900}' },
    },
    subtle: {
      value: { _light: '{colors.terracotta.400}', _dark: '{colors.terracotta.600}' },
    },
    muted: {
      value: { _light: '{colors.terracotta.300}', _dark: '{colors.terracotta.700}' },
    },
    subdued: {
      value: { _light: '{colors.terracotta.200}', _dark: '{colors.terracotta.800}' },
    },
    emphasized: {
      value: { _light: '{colors.terracotta.600}', _dark: '{colors.terracotta.400}' },
    },
    solid: {
      value: { _light: '{colors.terracotta.500}', _dark: '{colors.terracotta.500}' },
    },
    focusRing: {
      value: { _light: '{colors.terracotta.500}', _dark: '{colors.terracotta.500}' },
    },
    border: {
      value: { _light: '{colors.terracotta.200}', _dark: '{colors.terracotta.800}' },
    },
  },

  secondary: {
    contrast: { value: { _light: '{colors.white}', _dark: '{colors.white}' } },
    fg: { value: { _light: '{colors.teal.700}', _dark: '{colors.teal.300}' } },
    subtle: {
      value: { _light: '{colors.teal.100}', _dark: '{colors.teal.900}' },
    },
    muted: {
      value: { _light: '{colors.teal.200}', _dark: '{colors.teal.800}' },
    },
    emphasized: {
      value: { _light: '{colors.teal.600}', _dark: '{colors.teal.400}' },
    },
    solid: {
      value: { _light: '{colors.teal.600}', _dark: '{colors.teal.600}' },
    },
    focusRing: {
      value: { _light: '{colors.teal.400}', _dark: '{colors.teal.400}' },
    },
  },

  tertiary: {
    contrast: { value: { _light: '{colors.white}', _dark: '{colors.white}' } },
    fg: { value: { _light: '{colors.cyan.700}', _dark: '{colors.cyan.300}' } },
    subtle: {
      value: { _light: '{colors.cyan.100}', _dark: '{colors.cyan.900}' },
    },
    muted: {
      value: { _light: '{colors.cyan.200}', _dark: '{colors.cyan.800}' },
    },
    emphasized: {
      value: { _light: '{colors.cyan.600}', _dark: '{colors.cyan.400}' },
    },
    solid: {
      value: { _light: '{colors.cyan.600}', _dark: '{colors.cyan.500}' },
    },
    focusRing: {
      value: { _light: '{colors.cyan.400}', _dark: '{colors.cyan.400}' },
    },
  },

  accent1: {
    contrast: { value: { _light: '{colors.black}', _dark: '{colors.black}' } },
    fg: {
      value: { _light: '{colors.yellow.800}', _dark: '{colors.yellow.300}' },
    },
    subtle: {
      value: { _light: '{colors.yellow.100}', _dark: '{colors.yellow.900}' },
    },
    muted: {
      value: { _light: '{colors.yellow.200}', _dark: '{colors.yellow.800}' },
    },
    emphasized: {
      value: { _light: '{colors.yellow.300}', _dark: '{colors.yellow.700}' },
    },
    solid: {
      value: { _light: '{colors.yellow.300}', _dark: '{colors.yellow.300}' },
    },
    focusRing: {
      value: { _light: '{colors.yellow.400}', _dark: '{colors.yellow.400}' },
    },
  },

  accent2: {
    contrast: { value: { _light: '{colors.white}', _dark: '{colors.white}' } },
    fg: { value: { _light: '{colors.pink.700}', _dark: '{colors.pink.300}' } },
    subtle: {
      value: { _light: '{colors.pink.100}', _dark: '{colors.pink.900}' },
    },
    muted: {
      value: { _light: '{colors.pink.200}', _dark: '{colors.pink.800}' },
    },
    emphasized: {
      value: { _light: '{colors.pink.300}', _dark: '{colors.pink.700}' },
    },
    solid: {
      value: { _light: '{colors.pink.600}', _dark: '{colors.pink.600}' },
    },
    focusRing: {
      value: { _light: '{colors.pink.400}', _dark: '{colors.pink.400}' },
    },
  },

  status: {
    completed: {
      value: { _light: '{colors.green.300}', _dark: '{colors.green.700}' },
    },
    remaining: {
      value: { _light: '{colors.red.50}', _dark: '{colors.red.950}' },
    },
    pending: {
      value: { _light: '{colors.green.50}', _dark: '{colors.green.950}' },
    },
    inProgressLevel1: {
      value: { _light: '{colors.teal.200}', _dark: '{colors.teal.800}' },
    },
    inProgressLevel2: {
      value: { _light: '{colors.teal.300}', _dark: '{colors.teal.700}' },
    },
    inProgressLevel3: {
      value: { _light: '{colors.teal.400}', _dark: '{colors.teal.600}' },
    },
    onHold: {
      value: { _light: '{colors.yellow.200}', _dark: '{colors.yellow.800}' },
    },
    incomplete: {
      value: { _light: '{colors.orange.200}', _dark: '{colors.orange.800}' },
    },
    delayed: {
      value: { _light: '{colors.terracotta.200}', _dark: '{colors.terracotta.800}' },
    },
    failed: {
      value: { _light: '{colors.red.200}', _dark: '{colors.red.800}' },
    },
    blocked: {
      value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' },
    },
    success: {
      value: { _light: '{colors.green.600}', _dark: '{colors.green.500}' },
      bg: {
        value: { _light: '{colors.green.50}', _dark: '{colors.green.950}' },
      },
    },

    error: {
      value: { _light: '{colors.red.600}', _dark: '{colors.red.500}' },
      bg: { value: { _light: '{colors.red.50}', _dark: '{colors.red.950}' } },
    },
    warning: {
      value: { _light: '{colors.orange.600}', _dark: '{colors.orange.500}' },
      bg: {
        value: { _light: '{colors.orange.50}', _dark: '{colors.orange.950}' },
      },
    },
    warningLow: {
      value: { _light: '{colors.orange.400}', _dark: '{colors.orange.600}' },
      bg: {
        value: { _light: '{colors.orange.50}', _dark: '{colors.orange.950}' },
      },
    },
    warningHigh: {
      value: { _light: '{colors.orange.700}', _dark: '{colors.orange.400}' },
      bg: {
        value: { _light: '{colors.orange.50}', _dark: '{colors.orange.950}' },
      },
    },
    warning2: {
      value: { _light: '{colors.yellow.600}', _dark: '{colors.yellow.500}' },
      bg: {
        value: { _light: '{colors.yellow.100}', _dark: '{colors.yellow.900}' },
      },
    },
    warning2Low: {
      value: { _light: '{colors.yellow.400}', _dark: '{colors.yellow.600}' },
      bg: {
        value: { _light: '{colors.yellow.100}', _dark: '{colors.yellow.900}' },
      },
    },
    warning2High: {
      value: { _light: '{colors.yellow.700}', _dark: '{colors.yellow.400}' },
      bg: {
        value: { _light: '{colors.yellow.100}', _dark: '{colors.yellow.900}' },
      },
    },
    neutral: {
      value: { _light: '{colors.gray.600}', _dark: '{colors.gray.400}' },
    },
    info: {
      value: { _light: '{colors.blue.600}', _dark: '{colors.blue.400}' },
      bg: {
        value: { _light: '{colors.blue.50}', _dark: '{colors.blue.950}' },
      },
    },
  },

  chart: {
    green: {
      value: { _light: '{colors.green.600}', _dark: '{colors.green.500}' },
    },
    greenSubtle: {
      value: { _light: '{colors.green.700}', _dark: '{colors.green.300}' },
    },
    orange: {
      value: { _light: '{colors.orange.600}', _dark: '{colors.orange.500}' },
    },
    orangeSubtle: {
      value: { _light: '{colors.orange.700}', _dark: '{colors.orange.300}' },
    },

    red: {
      value: { _light: '{colors.red.600}', _dark: '{colors.red.500}' },
    },
    redSubtle: {
      value: { _light: '{colors.red.700}', _dark: '{colors.red.300}' },
    },
  },
};
